// src/App.js
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// Auth Pages
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";

// Dashboard & Layout
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Report from "./pages/Report";


// Expense Category Pages
import ExpenseCategoryIndex from "./pages/expensecategory/Index";
import ExpenseCategoryCreate from "./pages/expensecategory/Create";
import ExpenseCategoryEdit from "./pages/expensecategory/Edit";

import ContractGenerator from './pages/contracts/ContractGenerator';

// Customer Pages
import CustomerIndex from "./pages/customer/Index";
import CustomerCreate from "./pages/customer/Create";
import CustomerEdit from "./pages/customer/Edit";

// Employee Pages
import EmployeeIndex from "./pages/employee/Index";
import EmployeeCreate from "./pages/employee/Create";
import EmployeeEdit from "./pages/employee/Edit";

// Project Pages
import ProjectIndex from "./pages/project/Index";
import ProjectCreate from "./pages/project/Create";
import ProjectEdit from "./pages/project/Edit";

// Payment Pages
import PaymentIndex from "./pages/payment/Index";
import PaymentCreate from "./pages/payment/Create";
import PaymentEdit from "./pages/payment/Edit";

// Income Pages
import IncomeIndex from "./pages/income/Index";
import IncomeCreate from "./pages/income/Create";
import IncomeEdit from "./pages/income/Edit";

// Expense Pages
import ExpenseIndex from "./pages/expense/Index";
import ExpenseCreate from "./pages/expense/Create";
import ExpenseEdit from "./pages/expense/Edit";

// Withdrawal Pages
import WithdrawalIndex from "./pages/withdrawal/Index";
import WithdrawalCreate from "./pages/withdrawal/Create";
import WithdrawalEdit from "./pages/withdrawal/Edit";

// User Pages
import UserIndex from "./pages/user/Index";

// PrivateRoute: Only accessible if token exists
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />

        {/* Protected Routes - EVERYTHING ELSE goes inside Layout */}
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <Layout>
                <Routes>
                  {/* Dashboard */}
                  <Route path="dashboard" element={<Dashboard />} />

                  {/* Customers */}
                  <Route path="customers" element={<CustomerIndex />} />
                  <Route path="customers/create" element={<CustomerCreate />} />
                  <Route path="customers/edit/:id" element={<CustomerEdit />} />

                  {/* Employees */}
                  <Route path="employees" element={<EmployeeIndex />} />
                  <Route path="employees/create" element={<EmployeeCreate />} />
                  <Route path="employees/edit/:id" element={<EmployeeEdit />} />

                  {/* Report */}
                  <Route path="report" element={<Report />} />

                  {/* Projects */}
                  <Route path="projects" element={<ProjectIndex />} />
                  <Route path="projects/create" element={<ProjectCreate />} />
                  <Route path="projects/edit/:id" element={<ProjectEdit />} />

                  {/* Payments */}
                  <Route path="payments" element={<PaymentIndex />} />
                  <Route path="payments/create" element={<PaymentCreate />} />
                  <Route path="payments/edit/:id" element={<PaymentEdit />} />

                  {/* Incomes */}
                  <Route path="incomes" element={<IncomeIndex />} />
                  <Route path="incomes/create" element={<IncomeCreate />} />
                  <Route path="incomes/edit/:id" element={<IncomeEdit />} />

                  {/* Expenses */}
                  <Route path="expenses" element={<ExpenseIndex />} />
                  <Route path="expenses/create" element={<ExpenseCreate />} />
                  <Route path="expenses/edit/:id" element={<ExpenseEdit />} />

                  {/* Withdrawals */}
                  <Route path="withdrawals" element={<WithdrawalIndex />} />
                  <Route path="withdrawals/create" element={<WithdrawalCreate />} />
                  <Route path="withdrawals/edit/:id" element={<WithdrawalEdit />} />

                  {/* Users */}
                  <Route path="users" element={<UserIndex />} />

                  {/* Register User - INSIDE LAYOUT */}
                  <Route path="register" element={<Register />} />

                  <Route path="/projects/contract/:id" element={<ContractGenerator />} />

                  {/* Redirect unknown paths */}
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />


                  {/* Expense Categories */}
                  <Route path="expense-categories" element={<ExpenseCategoryIndex />} />
                  <Route path="expense-categories/create" element={<ExpenseCategoryCreate />} />
                  <Route path="expense-categories/edit/:id" element={<ExpenseCategoryEdit />} />
                </Routes>
              </Layout>
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;